import { render, staticRenderFns } from "./StepFarmerWork.vue?vue&type=template&id=8bfa548c&scoped=true&"
import script from "./StepFarmerWork.vue?vue&type=script&lang=js&"
export * from "./StepFarmerWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bfa548c",
  null
  
)

export default component.exports